import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/react-dates-override.css'
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import RegisterPage from './views/Register/RegisterPage/RegisterPage';
import LoginPage from './views/Login/LoginPage/LoginPage';
import EmployesPage from './views/Employes/EmployesPage/EmployesPage';
import Navbar from './components/Navbar/Navbar';
import ViewBar from './components/ViewBar/ViewBar';
import CreatePersonPage from './views/CreatePerson/CreatePersonPage/CreatePersonPage';
import CreateEmployeePage from './views/CreateEmployee/CreateEmployeePage/CreateEmployeePage';
import UsersPage from './views/Users/UsersPage/UsersPage';
import RenewSession from './components/RenewSession/RenewSession';
import GlobalStyle from './globalStyles'
import PrivateRoute from './PrivateRoute/PrivateRoute';
import PrivateRouteLogin from './PrivateRoute/PrivateRouteLogin';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import CertificatePage from './views/Certificate/CertificatePage/CertificatePage';
import VoucherPage from './views/Voucher/VoucherPage/VoucherPage';
import SupportPage from './views/Support/SupportPage/SupportPage'
import VerificationPage from './views/Verification/VerificationPage/VerificationPage';
import WhatsApp from './components/WhatsApp/whatsApp';
import CIRVoucherPage from './views/CIRVoucher/CIRVoucherPage/CIRVoucherPage';
import Password_managementPage from './views/Password_management/Password_managementPage/Password_managementPage';
import Swagger from './swagger/swagger';
import ValidateCertificate from './components/ValidateCertificate/ValidateCertificate';
import RetefuentePage from './views/Retefuente/RetefuentePage/RetefuentePage';
import LicensesPage from './views/Licenses/LicensesPage/LicensesPage';
import HistoricPage from './views/Historic/HistoricPage/HistoricPage';
import PendingPage from './views/Pending/PendingPage/PendingPage';
import HomePage from './views/Home/HomePage/HomePage';
import Instances from './components/Instances/Instances';
import { useEffect, useState } from 'react';
import Menu from './components/Menu/Menu';
import React from 'react'
import NoveltiesPage from './views/Novelties/NoveltiesPage/NoveltiesPage';
import TrackingReportPage from './views/TrackingReport/TrackingReportPage/TrackingReportPage';
import { LocationProvider } from './components/Maps/LocationContext';
import TeamWeekPage from './views/TeamWeek/TeamWeekPage/TeamWeekPage';
import WeekPage from './views/Week/WeekPage/WeekPage';
import DocumentsPage from './views/Documents/DocumentsPage/DocumentsPage';
import ValidateDocument from './components/ValidateDocument/ValidateDocument';
import SignDocument from './components/SignDocument/SignDocument';
import KioskoPage from './views/Kiosko/KioskoPage/KioskoPage';
import { useHistory } from "react-router-dom";
import DocumentSigning from './components/DocumentSigning/DocumentSigning';
import DashboardPage from './views/Dashboard/DashboardPage/DashboardPage';
import UsersManagementPage from './views/UsersManagement/UsersManagementPage/UsersManagementPage';
import Welcome from './components/Welcome/Welcome';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : App
Description : Se llama la barra de navegación, ya que esta es global y se definen las rutas para navegar entre vistas.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Modificación – Se definen las rutas de navegación y se incluye la barra de navegación.
27/10/2021 Santiago Coca Rojas Modificación - Se agregan más rutas para la totalidad de los componenstes definidos hasta la fecha.
28/10/2021 Santiago Coca Rojas Modificación - Se agrega componente de estilos globales,
2/11/2021 Cristian Andres Pizo Mina – Se agrego seguridad para las pantallas con el componente PrivateRoute
================================================================================ */

function App({ history, location }) {

  const [open, setOpen] = useState(false);
  const [contract, setContract] = useState({})
  const [contractList, setContractList] = useState([])
  const [redirected, setRedirected] = useState(false)

  useEffect(() => {
    if (contractList.length === 0 && localStorage.getItem('contracts') !== null) {
      console.log("Entra")
      try {
        let cont = JSON.parse(localStorage.getItem('contracts'))
        console.log(cont.filter((c) => c.contract_id === localStorage.getItem('contract_id')))
        setContractList(cont)
        setContract({
          contract_id: localStorage.getItem('contract_id'),
          description: cont.filter((c) => c.contract_id === localStorage.getItem('contract_id'))[0].description
        })
      }
      catch (err) {
        console.log('wait')
      }
    }
  }, [localStorage.getItem('contracts')])

  useEffect(() => {
    // Check if the user is on the specific page and set flag
    if (window.location.pathname === '/Kiosko') {
      setRedirected(true);
    }
  }, [window.location]);

  useEffect(() => {
    if (localStorage.getItem('kiosco')) {
      if (location.pathname !== "/Kiosko") {
        history.push('/Kiosko')
      }
    }
  }, [location, history])

  return (
    <>
      <Navbar open={open} setOpen={setOpen} contract={contract} setContract={setContract} contractList={contractList} setContractList={setContractList} />
      <div className="App surface-100 pb-8">
        {!localStorage.getItem('kiosco') && <Menu open={open} setOpen={setOpen} />}
        <RenewSession time={localStorage.getItem('expiration')} />
        <GlobalStyle />
        {/* <ViewBar /> */}
        {/* <WhatsApp /> */}
        <div className={open ? 'main-content-open' : 'main-content-close'}>
          <Switch>
            <Route path="/ValidateCertificate/:id" component={ValidateCertificate} />
            <Route path="/ValidateDocument" component={ValidateDocument} />
            <Route exact path="/"><Redirect to="/Login" /></Route>
            <PrivateRouteLogin exact path={"/Login"} component={LoginPage} />
            <Route exact path={"/Register"} component={RegisterPage} />
            <PrivateRoute exact path={"/Employes"} component={EmployesPage} />
            <PrivateRoute exact path={"/CreatePerson"} component={CreatePersonPage} />
            <PrivateRoute exact path={"/CreateEmployee"} component={CreateEmployeePage} />
            <PrivateRoute exact path={"/Users"} component={UsersPage} />
            <PrivateRoute exact path={"/Support"} component={SupportPage} />
            <PrivateRoute exact path={"/Certificate"} component={CertificatePage} />
            <PrivateRoute exact path={"/Voucher"} component={VoucherPage} />
            <PrivateRoute exact path={"/Verification"} component={VerificationPage} />
            <PrivateRoute exact path={"/CIRVoucher"} component={CIRVoucherPage} />
            <PrivateRoute exact path={"/PasswordManagement"} component={Password_managementPage} />
            <PrivateRoute exact path={"/Retefuente"} component={RetefuentePage} />
            <Route exact path={"/APIDocumentation"} component={Swagger} />
            <PrivateRoute exact path={"/Historic"} component={HistoricPage} />
            <PrivateRoute exact path={"/HistoricEmployees"} component={HistoricPage} />
            <PrivateRoute exact path={"/Licenses"} component={LicensesPage} />
            <PrivateRoute exact path={"/Pending"} component={PendingPage} />
            <PrivateRoute exact path={"/Home"} component={HomePage} />
            <PrivateRoute exact path={"/TI"} component={Instances} />
            <PrivateRoute exact path={"/TrackingReport"} component={TrackingReportPage} />
            <PrivateRoute exact path={"/MyTrackingReport"} component={TrackingReportPage} />
            <PrivateRoute exact path={"/TeamWeek"} component={TeamWeekPage} />
            <PrivateRoute exact path={"/Week"} component={WeekPage} />
            <PrivateRoute exact path={"/Documents"} component={DocumentsPage} />
            {/* <PrivateRoute exact path={"/SignDocument"} component={SignDocument} /> */}
            <PrivateRoute exact path={"/Kiosko"} component={KioskoPage} />
            <PrivateRoute exact path={"/DocumentSigning"} component={DocumentSigning} />
            <PrivateRoute exact path={"/Dashboard"} component={DashboardPage} />
            <PrivateRoute exact path={"/UsersManagement"} component={UsersManagementPage} />
            <PrivateRoute exact path={"/Welcome"} component={Welcome} />
            <LocationProvider>
              <PrivateRoute exact path={"/Novelties"} component={NoveltiesPage} />
            </LocationProvider>
          </Switch>
        </div>
      </div>
    </>
  );
}

export default withRouter(App);
